import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Vellore() {
  const [openFaq, setOpenFaq] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const whyWowcarzCards = [
    {
      title: "Wide Range of Cars",
      text: "Self drive car rental in Vellore with a wide range of well-maintained vehicles for every need.",
    },
    {
      title: "Instant Booking",
      text: "Enjoy a hassle-free rental experience with instant booking and quick confirmation.",
    },
    {
      title: "24/7 Pickup & Drop",
      text: "Available round the clock at Vellore Railway Station, Bus Stand, or even doorstep delivery.",
    },
    {
      title: "Flexible Packages",
      text: "Choose from 100 km, 250 km, or 350 km packages to suit short, long, or city trips.",
    },
    {
      title: "Perfect for All Trips",
      text: "Ideal for city rides, weekend getaways, or long-distance journeys — drive your way with ease.",
    },
  ];

  const places = [
    {
      image: "/assets/vellorefort.png",
      title: "Vellore Fort",
      desc: "One of the most iconic landmarks in Tamil Nadu, Vellore Fort is famous for its grand architecture and rich history. Built in the 16th century, it houses a church, a mosque, and a temple within its premises.",
    },
    {
      image: "/assets/jalakandeswarartemple.jpg",
      title: "Jalakandeswarar Temple",
      desc: "Located inside the fort, this temple is dedicated to Lord Shiva and is known for its intricate carvings and stunning architecture.",
    },
    {
      image: "/assets/sripuramgoldentemple.jpg",
      title: "Sripuram Golden Temple",
      desc: "A spiritual landmark, the Golden Temple at Sripuram is fully covered with gold sheets and attracts devotees from across the world. It’s a must-visit for peace and divine blessings.",
    },
    {
      image: "/assets/johnschurch.jpg",
      title: "St. John’s Church",
      desc: "One of the oldest churches in Vellore, this spot is perfect for history lovers and those seeking serenity.",
    },
    {
      image: "/assets/amritipark.jpg",
      title: "Amirthi Zoological Park",
      desc: "Ideal for families and kids, this mini zoo offers a natural escape with trekking trails, waterfalls, and wildlife.",
    },
    {
      image: "/assets/periyarpark.jpg",
      title: "Periyar Park",
      desc: "A refreshing spot in the city, Periyar Park is perfect for morning walks, family outings, and relaxation.",
    },
    {
      image: "/assets/yellagirihills.jpg",
      title: "Yelagiri Hills (100 km trip)",
      desc: "For those looking for a short trip within 100kms, Yelagiri Hills is the best option. Known for its pleasant climate, trekking, boating, and nature walks.",
    },
    {
      image: "/assets/kanchipuram.jpg",
      title: "Kanchipuram (120 km trip)",
      desc: "Perfect for a day trip around 250kms, Kanchipuram is famous for its silk sarees and historic temples.",
    },
    {
      image: "/assets/tirupatibalajitemple.jpg",
      title: "Tirupati Balaji Temple (130 km trip)",
      desc: "One of India’s most visited temples, Tirupati is an ideal long trip from Vellore within 250-350kms.",
    },
  ];

  const faqs = [
    {
      q: "How can I book a self drive car in Vellore with Wow carz?",
      a: "You can book online at wowcarz.in or call our customer support. We offer quick confirmation and hassle free rental.",
    },
    {
      q: "Do you provide pick up and drop at Vellore Railway Station and Bus Stand?",
      a: "Yes, Wow carz provides 24/7 pick up and drop services at Railway Station, Bus Stand, and even doorstep delivery.",
    },
    {
      q: "What is the minimum distance package available?",
      a: "We offer flexible packages for 100kms, 250kms, and 350kms, suitable for short and long trips.",
    },
    {
      q: "Can I take the car for outstation trips like Tirupati or Kanchipuram?",
      a: "Absolutely! Wow carz allows long trips up to 350kms and beyond, perfect for Tirupati, Kanchipuram, and Yelagiri.",
    },
    {
      q: "Do I need to pay extra for fuel?",
      a: "Yes, fuel is the customer's responsibility. Our cars come with full tank, and you can refill as per usage.",
    },
  ];

  const sliderSettings = {
    dots: true,
    responsive: [{ breakpoint: 768, settings: { arrows: false } }],
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="min-h-screen bg-grey-50 text-gray-800 font-inter">
      {/* Header */}
      <header className="bg-red-100 shadow-sm sticky top-0 z-20">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              onClick={() => navigate("/")}
              loading="lazy"
              style={{ height: 55, width: 160 }}
              src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
              alt="wowcarzlogo"
              className="object-cover cursor-pointer"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
            <div className="flex items-center gap-3 mt-2 sm:mt-0">
              <a
                href="/"
                className="bg-red-500 text-white px-4 py-2 rounded-lg shadow hover:bg-red-700 transition"
              >
                Book Now
              </a>
              <a
                href="tel:+919844300066"
                className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
              >
                📞 Call Us
              </a>
            </div>
          </div>
        </div>
      </header>


      <main className="max-w-8xl mx-auto sm:px-6 lg:px-8 py-10">
        {/* Hero Section */}
        <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">

          <img
            src="/assets/vel.jpg"
            alt="Self Drive Cars Chennai"
            className="absolute inset-0 w-full h-full object-contain scale-[1.75]"
          />
          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12">
            <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 animate-fade-in">
              Explore Vellore with Wow carz
            </h2>
            <p className="text-gray-200 text-base sm:text-lg mb-6 max-w-xl leading-relaxed">
              Explore Vellore and nearby destinations with hassle-free self
              drive cars from Wow Carz.
            </p>
          </div>
        </section>

        <section className="bg-red-200 p-5 m-5">
          <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
              Explore Vellore with Wow Carz
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Planning to visit Vellore, the “Fort City” of Tamil Nadu? Whether
              you’re here for a short trip, long trip, or weekend getaway,
              Vellore offers a mix of history, spirituality, and modern
              attractions. With Wow carz self drive car in Vellore, you can
              travel at your own pace, rent a car hassle free, and enjoy both
              travel within city and road trips up to 100kms, 250kms, or even
              350kms around Vellore. <strong>Wow carz</strong> provides self drive car rental in
              Vellore with 24/7 doorstep delivery, pick up and drop at Vellore
              Railway Station & Bus Stand, ensuring your journey starts
              smoothly.
            </p>
          </div>
        </section>


        {/* Why Wowcarz Section */}
        <section className="py-12 bg-gray-50">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-10 text-center">
            Why Choose Wow Carz in Vellore?
          </h2>

          {isMobile ? (
            <Slider {...sliderSettings}>
              {whyWowcarzCards.map((card, index) => (
                <div key={index} className="p-4">
                  <div className="bg-white p-6 rounded-2xl shadow-lg">
                    <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                    <p className="text-gray-600">{card.text}</p>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 justify-items-center">
              {whyWowcarzCards.map((card, index) => (
                <div
                  key={index}
                  className="cursor-pointer overflow-hidden p-5 relative w-64 h-64 rounded-xl bg-white shadow hover:shadow-lg transition-all duration-500"
                >
                  <div className="w-full h-full flex flex-col justify-center gap-2">
                    <span className="text-gray-900 font-bold text-xl italic">
                      {card.title}
                    </span>
                    <p className="text-black text-sm">{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* Plan Your Trip */}
        <section className="py-12 sm:py-14 lg:py-16 bg-red-400 m-4 sm:mx-6 lg:mx-10 rounded-2xl">
          <div className="max-w-7xl mx-auto text-center px-4">

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-10 lg:mb-12 text-gray-900">
              Plan Your Trip to Vellore
            </h2>

            {(() => {
              const cards = [
                {
                  icon: "🏛️",
                  iconBg: "bg-purple-100",
                  title: "Interesting Facts About Vellore",
                  desc: "Vellore is a historic city in Tamil Nadu known for its rich cultural heritage. The famous Vellore Fort is one of the best-preserved forts in South India. The city is also home to Sripuram Golden Temple and the prestigious VIT University.",
                },
                {
                  icon: "🎉",
                  iconBg: "bg-red-100",
                  title: "Famous Festivals in Vellore",
                  desc: "Major festivals celebrated in Vellore include Pongal, Diwali, Navaratri, and temple festivals at Jalakandeswarar Temple and Sripuram Golden Temple bringing vibrant celebrations across the city.",
                },
                {
                  icon: "🌤️",
                  iconBg: "bg-yellow-100",
                  title: "Best Time to Visit Vellore",
                  desc: "The best time to visit Vellore is from October to March when the weather is pleasant for sightseeing. Visitors can explore Vellore Fort, Sripuram Golden Temple, and nearby Yelagiri Hills comfortably.",
                },
              ];

              return (
                <>
                  {/* Desktop Grid */}
                  <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {cards.map((card, i) => (
                      <div key={i} className="bg-white p-6 sm:p-7 lg:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                        <div className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-xl sm:text-2xl ${card.iconBg}`}>
                          {card.icon}
                        </div>
                        <h3 className="text-lg sm:text-xl font-semibold mb-3">
                          {card.title}
                        </h3>
                        <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                          {card.desc}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Mobile Carousel */}
                  <div className="block md:hidden">
                    <Slider {...sliderSettings}>
                      {cards.map((card, i) => (
                        <div key={i} className="px-3">
                          <div className="bg-white p-6 rounded-2xl shadow-md text-center">
                            <div className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-xl ${card.iconBg}`}>
                              {card.icon}
                            </div>
                            <h3 className="text-lg font-semibold mb-3">
                              {card.title}
                            </h3>
                            <p className="text-gray-700 text-sm">
                              {card.desc}
                            </p>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </>
              );
            })()}

          </div>
        </section>

        {/* Top Places Section */}
        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Top Places to Visit in Vellore
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Explore iconic landmarks, serene gardens, and historic towns with
            your Wow Carz ride.
          </p>

          {isMobile ? (
            <Slider {...sliderSettings}>
              {places.map((place, index) => (
                <div key={index} className="p-4">
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <img
                      className="w-48 h-48 object-cover rounded-xl mx-auto mb-4"
                      src={place.image}
                      alt={place.title}
                    />
                    <h4 className="font-semibold text-xl text-gray-800 mb-2">
                      {place.title}
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {place.desc}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
              {places.map((place, index) => (
                <article
                  key={index}
                  className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-blue-300 transition-transform duration-300 transform hover:-translate-y-2 hover:scale-105 text-center"
                >
                  <div className="overflow-hidden rounded-xl mb-4">
                    <img
                      className="w-48 h-48 object-cover rounded-xl mx-auto transition-transform duration-300 transform hover:scale-110"
                      src={place.image}
                      alt={place.title}
                    />
                  </div>
                  <h4 className="font-semibold text-xl text-gray-800 mb-2">
                    {place.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {place.desc}
                  </p>
                </article>
              ))}
            </div>
          )}
        </section>

        {/* FAQ Section */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">
            Frequently Asked Questions
          </h3>
          <div className="space-y-4">
            {faqs.map((f, i) => (
              <div
                key={i}
                className="border rounded-xl bg-white shadow-sm overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full text-left px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition"
                >
                  <span className="font-medium text-gray-800">{f.q}</span>
                  <span className="text-gray-500 text-lg">
                    {openFaq === i ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`px-5 overflow-hidden transition-all duration-300 ${openFaq === i ? "max-h-40 py-3" : "max-h-0"
                    }`}
                >
                  <p className="text-gray-700 text-sm leading-relaxed">{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mt-16 bg-gradient-to-r from-red-300 via-red-400 to-red-500 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <h4 className="text-2xl font-semibold">
              Ready to Start Your Journey?
            </h4>
            <p className="text-sm mt-2 text-blue-100">
              Experience hassle-free driving with Wow Carz today.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href="/"
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
            >
              Book Now
            </a>
            <a
              href="tel:+919844300066"
              className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
            >
              Call Us
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-10 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Wow Carz — All rights reserved
        </footer>
      </main>
    </div>
  );
}

export default Vellore;
